import { render, staticRenderFns } from "./SecondaryTitle.vue?vue&type=template&id=07f32e2a&scoped=true"
var script = {}
import style0 from "./SecondaryTitle.vue?vue&type=style&index=0&id=07f32e2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f32e2a",
  null
  
)

export default component.exports